interface Props {
    class?: string,
    maxLength?: number,
    placeholder: string,
    value: string | number,
    onChange: Function,
}

function Search(props:Props) {
    return (
        <div className={`search-1 ${props.class}`}>
            <div className="search_wrap">
                <svg className="search_before" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path fillRule="evenodd" clipRule="evenodd" d="M2.75 9.625a6.875 6.875 0 0 0 11.088 5.434c.044.092.104.18.18.256l3.478 3.477a.917.917 0 0 0 1.296-1.297l-3.477-3.477a.914.914 0 0 0-.256-.18A6.875 6.875 0 1 0 2.75 9.625Zm1.834 0a5.042 5.042 0 1 1 10.083 0 5.042 5.042 0 0 1-10.083 0Z" fill="#C8C8C8"/></svg>
                <input type="text" className="products_search" id='main_products_search' 
                    placeholder={props.placeholder} 
                    autoComplete="off" 
                    value={props.value} 
                    onChange={e => props.onChange(e.target.value)} 
                    maxLength={props.maxLength}
                    spellCheck='false'
                />
            </div>
        </div>
    );
}

export default Search;